export * from './Footer';
export { StyledAwardBadge } from './Footer.styled';
